import { observer } from "mobx-react";
import { h } from "preact";
function BarAlert(props) {
    const { message, type, icon, fieldId } = props;
    const fieldIdProps = fieldId === undefined
        ? {}
        : { "data-field-id": fieldId, "data-field-type": "info" };
    const hasIcon = icon !== undefined;
    return (h("div", { class: `m-alert m-alert--${type} m-alert--bar`, ...fieldIdProps, role: type === "danger" ? "alert" : "status" },
        h("button", { type: "button", class: "m-alert__btn u-btn-unstyled", disabled: props.disabled, onClick: props.onClick },
            message,
            hasIcon && (h("span", { class: `m-alert__icon icon-${icon}`, "aria-hidden": "true" })))));
}
export default observer(BarAlert);
